import React, { useEffect, useState } from 'react'
import { CommonHeader, ErrorSuccessModal, Loader } from '../../../../components/commons'
import { getAllFinacManagerAction, getAllFinacUsersAction, resetFinacManagerList, resetFinacUsersList, resetSession, resetTotalManagerCount } from '../../../../redux/auth'
import { RootState } from '../../../../redux/rootReducers'
import { AddJobsPayload, GetJobsListTypePayload, JobError, JobsType } from '../../../../commonTypes/jobsType'
import {  addJobsAction, getJobsTypeListAction, resetError, resetMessage, resetStatusCode, resetSuccess } from '../../../../redux/jobs'
import { connect } from 'react-redux'
import "../../styles/jobs.scss"
import AddJobsCard from '../../../../components/Jobs/Jobs'
import { GetClientDirectoryListPayloadType } from '../../../../commonTypes/clientDirectoryTypes'
import { getClientDirectoryListAction } from '../../../../redux/clientDirectory'
import useDebounce from '../../../../customHooks/useDebounce'
import { ClientDirectoryListType } from '../../../../redux/clientDirectory/clientDirectoryType'
import { GetAllFinacUserPayloadType } from '../../../../commonTypes/authTypes'
import { FinacUsersType } from '../../../../redux/auth/authTypes'



type AppProps = {
    token: string | null;
    success: number | null;
    fetching: boolean;
    error: string | null | undefined;
    message: string;
    statusCode: number | null;
    history?: any;
    finacUser: FinacUsersType[];
    finacManagerList: FinacUsersType[];
    userFetching: boolean;
    managerFetching: boolean;
    totalManagerCount: string | number;
    clientDirectoryList: [] | ClientDirectoryListType[];
    totalCount: number | null;
    dispatchAddJobs: (data: AddJobsPayload) => void;
    dispatchResetSession: () => void;
    dispatchResetError: () => void;
    dispatchResetSuccess: () => void;
    dispatchResetMessage: () => void;
    dispatchResetStatusCode: () => void;
    dispatchGetClientDirectoryListAction: (data: GetClientDirectoryListPayloadType) => void,
}


const AddJobs = ({
    token,
    success,
    fetching,
    error,
    statusCode,
    history,
    message,
    finacUser,
    finacManagerList,
    clientDirectoryList,
    totalCount,
    userFetching,
    managerFetching,
    totalManagerCount,
    dispatchResetSession,
    dispatchResetMessage,
    dispatchAddJobs,
    dispatchGetClientDirectoryListAction,
    dispatchResetError,
    dispatchResetSuccess,
    dispatchResetStatusCode
}: AppProps) => {

    const [jobsData, setJobsData] = useState<JobsType>({
        client: { value: "", label: "Select.." },
        jobType: { value: "", label: "Select.." },
        periodEnded: "",
        jobPriority: { value: "", label: "Select" },
        targetStartDate: "",
        targetEndDate: "",
        jobDesc: "",
        currResponsible: { value: "", label: "" },
        jobPartner: { value: "", label: "" },
        jobManager: { value: "", label: "" },
        govtOfficer: {value: "", label: ""},
        jobOwner: { value: "", label: "" },
        agreedFees: "",
        budgetTotal: "",
        jobStatus: true,
    })


    const [text, setText] = useState<string>("")
    const [offset, setOffset] = useState<number>(0);
    const [limit, setLimit] = useState<number>(20);

    const [jobsError, setJobsError] = useState<JobError>({
        jobType: "",
        client: "",
        periodEnded: "",
        jobManager: "",
        currResponsible: ""
    });

    const [startDateError,setStateDateError]= useState("")

    useEffect(() => {
        window.scroll({
            top:0,
            left:0
          })
        dispatchResetMessage()
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetStatusCode()
        resetData()
    }, [])

    useEffect(() => {
        if (token && totalCount) {
            if (offset <= +totalCount) {
                const finalData = {
                    token,
                    status: 1,
                    offset,
                    limit,
                    searchValue: text,
                }
                dispatchGetClientDirectoryListAction(finalData)
            }
        }
    }, [offset])

    const fetchNewData = () => {
        const finalData = {
            token,
            status: 1,
            offset,
            limit,
            searchValue: text,
        }
        dispatchGetClientDirectoryListAction(finalData)
    }

    useDebounce(() => {
        if (text) {
            fetchNewData()
        }
    }, 500, [text])



    const handleChange = (data: any, name: string) => {
      
        switch (name) {
            case "jobDesc":
            case "agreedFees":
            case "budgetTotal":
                setJobsData((prev: JobsType) => ({ ...prev, [name]: data.target.value }))
                setJobsError((prev: JobError) => ({ ...prev, [name]: "" }))
                break;
            case "periodEnded":
            case "targetStartDate":
                case "targetEndDate":
                setJobsData((prev: JobsType) => ({ ...prev, [name]: data }))
                setJobsError((prev: JobError) => ({ ...prev, [name]: "" }));
                setStateDateError("")
                break;
            case "jobStatus":
                setJobsData((prev: JobsType) => ({ ...prev, [name]: !jobsData.jobStatus }))
                setJobsError((prev: JobError) => ({ ...prev, [name]: "" }))
                break;
            default:
                setJobsData((prev: JobsType) => ({ ...prev, [name]: { ...data } }))
                setJobsError((prev: JobError) => ({ ...prev, [name]: "" }))
                
        }
    }
  
    const handleSubmit = () => {
        const { client, jobType, jobStatus, periodEnded, jobPriority, targetStartDate, targetEndDate,
            jobDesc, currResponsible, jobPartner, govtOfficer, jobManager, jobOwner, agreedFees, budgetTotal } = jobsData
        if (targetStartDate && targetEndDate) {

            
            const dateCheck = new Date(targetStartDate?.split("-").reverse().join(",")) > new Date(targetEndDate?.split("-").reverse().join(","))
            if (dateCheck) {
                setStateDateError("Target Start Date should be less than Target End Date");
                return
            }
        }
        if (client?.value && jobType?.value && periodEnded && currResponsible?.value && jobManager?.value) {
            let finalData = {
                client_code: client?.value,
                job_type: jobType?.value,
                period_ended: periodEnded,
                job_priority: jobPriority?.value,
                target_start_date: targetStartDate,
                target_end_date: targetEndDate,
                job_description: jobDesc,
                currently_responsible: currResponsible?.value,
                job_partner: jobPartner?.value,
                govt_officer: govtOfficer?.value,
                job_manager: jobManager?.value,
                job_owner: jobOwner?.value,
                agreed_fee: agreedFees,
                budget_total: budgetTotal,
                job_status: jobStatus ? "Open" : "Closed"
            }
            dispatchAddJobs({ data: finalData, token })
        }

        else {
            setJobsError((prev: JobError) => ({
                ...prev,
                ...(!jobType?.value ?
                    { jobType: 'Required' } : { jobType: '' }),
                ...(!client?.value ?
                    { client: 'Required' } : { client: '' }),
                ...(!periodEnded ?
                    { periodEnded: 'Required' } : { periodEnded: '' }),
                ...(! currResponsible?.value?
                    { currResponsible: 'Required' } : { currResponsible: '' }),
                ...(!jobManager?.value ?
                    { jobManager: 'Required' } : { jobManager: '' }),

            }))
        }
    }

    const resetData = () => {
        setJobsError({
            jobType: "",
            client: "",
            periodEnded: "",
            jobManager:"",
            currResponsible:""
        })
        setStateDateError("")
        setJobsData({
            client: { value: "", label: "Select.." },
            jobType: { value: "", label: "Select.." },
            periodEnded: "",
            jobPriority: { value: "", label: "Select" },
            targetStartDate: "",
            targetEndDate: "",
            jobDesc: "",
            currResponsible: { value: "", label: "" },
            jobPartner: { value: "", label: "" },
            jobManager: { value: "", label: "" },
            govtOfficer: {value: "", label: ""},
            jobOwner: { value: "", label: "" },
            agreedFees: "",
            budgetTotal: "",
            jobStatus: true,
        })
    }

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetSuccess();
                            dispatchResetError();
                        }}
                    />
                )
            }
        }
        else if (success === 1 && message=="Job has been added successfully!") {
            return (
                <ErrorSuccessModal
                    type="success"
                    isOpen={success === 1}
                    title="Success"
                    message="Job Added Successfully"
                    buttonText="OK"
                    onPress={() => {
                        dispatchResetSuccess();
                        history?.push({pathname:"/jobs/jobs-list",state:{}})
                    }}
                    statusCode={statusCode}
                />
            )
        }

        return false;
    }


    return (
        <div className="row">
            <div className="col-md-4 mb-3">
                <CommonHeader title="Create Jobs" />
            </div>

            <div className="col-md-12">
                <div className='jobs-card' style={{ padding: "15px 30px" }}>

                    <div className='heading'> Create Jobs</div>
                    <div className='sub-heading'>Create jobs here</div>

                    <AddJobsCard
                        jobsData={jobsData}
                        setJobsData={setJobsData}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        jobsError={jobsError}
                        history={history}
                        resetData={resetData}
                        startDateError={startDateError}
                        setJobsError={setJobsError}
                        setStateDateError={setStateDateError}
                    />

                </div>
            </div>
            {handleErrorModal()}
            {fetching&&<Loader/>}
        </div>
    )
}

const mapStateTopProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.jobs.fetching,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    error: state.jobs.error,
    message: state.jobs.message,
    jobsTypeList: state.jobs.jobsTypeList,
    finacUser: state.auth.finacUsersList,
    userFetching: state.auth.fetching,
    managerFetching: state.auth.managerFetching,
    finacManagerList: state.auth.finacManagerList,
    totalManagerCount: state.auth.totalManagerCount,
    totalCount: state.clientDirectory.totalCount,
    clientDirectoryList: state.clientDirectory.clientDirectoryList
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetMessage: () => dispatch(resetMessage()),
    dispatchResetSuccess: () => dispatch(resetSuccess()),
    dispatchResetStatusCode: () => dispatch(resetStatusCode()),
    dispatchResetError: () => dispatch(resetError()),
    dispatchAddJobs: (data: AddJobsPayload) => dispatch(addJobsAction(data)),
    dispatchGetClientDirectoryListAction: (data: GetClientDirectoryListPayloadType) => dispatch(getClientDirectoryListAction(data)),
    dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
    dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacManagerAction(data)),
    dispatchGetAllJobsTypeListAction: (data: GetJobsListTypePayload) => dispatch(getJobsTypeListAction(data)),
    dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
    dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
    dispatchResetTotalManagerCount: () => dispatch(resetTotalManagerCount()),
})

export default connect(mapStateTopProps, mapDispatchToProps)(AddJobs)